import {
  CameraIcon,
  GanttChartSquare,
  Palette,
  Smile,
  SmilePlus
} from "lucide-react";
import profile from "../../assets/images/profile.jpg";

export const AddCommentBox = () => (
  <div className="flex items-start space-x-3 mt-4">
    <img
      src={profile}
      alt="User Avatar"
      className="w-9 h-9 rounded-full"
    />
    <div className="flex-1  bg-gray-100 rounded-2xl">
      <div className="flex items-center rounded-full px-4 py-2">
        <span className="text-sm text-gray-700 flex-1">
          Comment here...
        </span>
        <span className="text-gray-500 text-xl">➤</span>
      </div>
      <div className="flex items-center gap-3 mt-2 ml-2 pb-2 text-gray-600">
        <SmilePlus className="w-5 h-5" />
        <Smile className="w-5 h-5" />
        <CameraIcon className="w-5 h-5" />
        <GanttChartSquare className="w-5 h-5" />
        <Palette className="w-5 h-5" />
      </div>
    </div>
  </div>
);

export default AddCommentBox;
